// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hYBZ","tabsBox":"styles_tabsBox__3NOjz","createButton":"styles_createButton__2cF9c"};